import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-customer-report-home',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './customer-report-home.component.html',
  styleUrl: './customer-report-home.component.scss',
})
export class CustomerReportHomeComponent {}
